import React, { useEffect, useRef, useState } from 'react';

const TimeSelector = ({ time, onChange, format12h = true }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [tempHour, setTempHour] = useState(time.split(':')[0]);
  const [tempMinute, setTempMinute] = useState(time.split(':')[1]);
  const [amPm, setAmPm] = useState('AM');
  const wrapperRef = useRef(null);

  const convertTo12h = (hour24) => {
    const h = parseInt(hour24, 10);
    const period = h >= 12 ? 'PM' : 'AM';
    const hour12 = h % 12 === 0 ? 12 : h % 12;
    return { hour: String(hour12).padStart(2, '0'), period };
  };

  const convertTo24h = (hour12, period) => {
    let h = parseInt(hour12, 10);
    if (period === 'PM' && h < 12) h += 12;
    if (period === 'AM' && h === 12) h = 0;
    return String(h).padStart(2, '0');
  };

  const hourOptions = format12h
    ? Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, '0'))
    : Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0'));

  const minuteOptions = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, '0'));

  const handleConfirm = () => {
    const hourFinal = format12h ? convertTo24h(tempHour, amPm) : tempHour;
    onChange(`${hourFinal}:${tempMinute}`);
    setIsOpen(false);
  };

  useEffect(() => {
    const [h, m] = time.split(':');
    setTempMinute(m);
    if (format12h) {
      const { hour, period } = convertTo12h(h);
      setTempHour(hour);
      setAmPm(period);
    } else {
      setTempHour(h);
    }
  }, [isOpen, time, format12h]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div style={{ position: 'relative', width: '100%' }} ref={wrapperRef}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        style={{
          width: '100%',
          padding: '10px',
          fontSize: '16px',
          cursor: 'pointer',
          border: '1px solid #ccc',
          background: 'transparent',
        }}
      >
        {format12h
          ? `${tempHour}:${tempMinute} ${amPm}`
          : `${tempHour}:${tempMinute}`}
      </button>

      {isOpen && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            zIndex: 10,
            background: '#fff',
            border: '1px solid #ccc',
            width: '100%',
            marginTop: '4px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
          }}
        >
          <div style={{ display: 'flex' }}>
            <div style={{
              maxHeight: '150px', overflowY: 'scroll', flex: 1, borderRight: '1px solid #eee',
            }}
            >
              {hourOptions.map((h) => (
                <button
                  type="button"
                  key={h}
                  onClick={() => setTempHour(h)}
                  style={{
                    boxSizing: 'border-box',
                    all: 'unset',
                    padding: '8px 0px',
                    textAlign: 'center',
                    cursor: 'pointer',
                    background: h === tempHour ? '#d0eaff' : 'transparent',
                    width: '100%',
                    display: 'block',
                  }}
                >
                  {h}
                </button>
              ))}
            </div>

            <div style={{ maxHeight: '150px', overflowY: 'scroll', flex: 1 }}>
              {minuteOptions.map((m) => (
                <button
                  type="button"
                  key={m}
                  onClick={() => setTempMinute(m)}
                  style={{
                    boxSizing: 'border-box',
                    all: 'unset',
                    padding: '8px 0px',
                    textAlign: 'center',
                    cursor: 'pointer',
                    background: m === tempMinute ? '#d0eaff' : 'transparent',
                    width: '100%',
                    display: 'block',
                  }}
                >
                  {m}
                </button>
              ))}
            </div>

            {format12h && (
              <div style={{
                maxHeight: '150px', overflowY: 'scroll', flex: 0.7, borderLeft: '1px solid #eee',
              }}
              >
                {['AM', 'PM'].map((p) => (
                  <button
                    type="button"
                    key={p}
                    onClick={() => setAmPm(p)}
                    style={{
                      boxSizing: 'border-box',
                      all: 'unset',
                      padding: '8px 0px',
                      textAlign: 'center',
                      cursor: 'pointer',
                      background: p === amPm ? '#d0eaff' : 'transparent',
                      width: '100%',
                      display: 'block',
                    }}
                  >
                    {p}
                  </button>
                ))}
              </div>
            )}
          </div>

          <div style={{ padding: '8px', textAlign: 'center' }}>
            <button
              type="button"
              onClick={handleConfirm}
              style={{
                padding: '6px 12px',
                background: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
            >
              Confirmar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TimeSelector;
